(function (w, d) {
  if (w.__ES_THEME_RUNTIME_BOOTED && typeof w.__ES_THEME_RUNTIME_REHYDRATE === 'function') {
    try { w.__ES_THEME_RUNTIME_REHYDRATE(); } catch (e) {}
    return;
  }
  w.__ES_THEME_RUNTIME_BOOTED = true;

  var flags = w.ES_THEME_FLAGS || {};
  var revealTimer = 0;

  /*
   * EYESHELLS shared runtime foundation.
   * Keep the API deliberately small: diagnostics, media, events, resources,
   * and a shared DOM mutation channel. Feature modules may retain their own
   * business logic while using one source of truth for infrastructure.
   */
  var ES = w.ES = w.ES || {};
  ES.version = '1480';
  ES.designMode = !!(w.Shopify && w.Shopify.designMode);

  function runtimeDetail(source, message, error, meta) {
    return {
      source: source || 'runtime',
      message: message || (error && error.message) || 'Unknown runtime error',
      error: error || null,
      meta: meta || null,
      timestamp: Date.now()
    };
  }

  ES.diagnostics = ES.diagnostics || {};
  ES.diagnostics.report = function (level, source, message, error, meta) {
    var detail = runtimeDetail(source, message, error, meta);
    try { d.dispatchEvent(new CustomEvent('es:runtime-error', { detail: detail })); } catch (_eventError) {}
    if (!ES.designMode || !w.console) return detail;
    try {
      var method = level === 'error' ? 'error' : (level === 'info' ? 'info' : 'warn');
      if (typeof w.console[method] === 'function') {
        w.console[method]('[EYESHELLS][' + detail.source + '] ' + detail.message, error || '', meta || '');
      }
    } catch (_consoleError) {}
    return detail;
  };
  ES.debug = function (source, message, meta) { return ES.diagnostics.report('info', source, message, null, meta); };
  ES.warn = function (source, message, error, meta) { return ES.diagnostics.report('warn', source, message, error, meta); };
  ES.error = function (source, message, error, meta) { return ES.diagnostics.report('error', source, message, error, meta); };

  ES.media = ES.media || {};
  ES.media.query = function (query) {
    try { return w.matchMedia ? w.matchMedia(query) : null; }
    catch (error) { ES.warn('media', 'Capability query failed: ' + query, error); return null; }
  };
  ES.media.matches = function (query, fallback) {
    var mq = ES.media.query(query);
    return mq ? mq.matches : !!fallback;
  };
  ES.media.onMatch = function (query, callback, options) {
    var mq = ES.media.query(query);
    var opts = options || {};
    if (!mq) {
      if (opts.fallbackMatch !== false) callback(null);
      return function () {};
    }
    if (mq.matches && opts.immediate !== false) callback(mq);
    var listener = function (event) { if (event.matches) callback(event); };
    if (mq.addEventListener) mq.addEventListener('change', listener);
    else if (mq.addListener) mq.addListener(listener);
    return function () {
      try {
        if (mq.removeEventListener) mq.removeEventListener('change', listener);
        else if (mq.removeListener) mq.removeListener(listener);
      } catch (_removeMediaError) {}
    };
  };

  ES.events = ES.events || {};
  ES.events.on = function (target, name, handler, options) {
    var node = target || d;
    node.addEventListener(name, handler, options);
    return function () { try { node.removeEventListener(name, handler, options); } catch (_removeEventError) {} };
  };
  ES.events.once = function (target, name, handler, options) {
    var opts = options && typeof options === 'object' ? Object.assign({}, options, { once: true }) : { once: true };
    return ES.events.on(target, name, handler, opts);
  };

  ES.loader = ES.loader || {};
  ES.loader.registry = ES.loader.registry || {};
  function findResource(type, key, src, selector) {
    if (selector) {
      try { return d.querySelector(selector); } catch (_selectorError) {}
    }
    var attr = type === 'style' ? 'href' : 'src';
    var nodes = d.querySelectorAll(type === 'style' ? 'link[rel="stylesheet"]' : 'script[src]');
    for (var i = 0; i < nodes.length; i += 1) {
      var value = nodes[i].getAttribute(attr) || '';
      if ((src && value === src) || (key && nodes[i].getAttribute('data-es-resource-key') === key)) return nodes[i];
    }
    return null;
  }
  function loadResource(type, key, src, options) {
    var opts = options || {};
    var id = key || src;
    if (!src) return Promise.resolve(false);
    if (ES.loader.registry[id]) return ES.loader.registry[id];
    var existing = findResource(type, key, src, opts.selector);
    if (existing) {
      var alreadyLoaded = existing.getAttribute('data-es-loaded') === '1';
      if (!alreadyLoaded && type === 'style') {
        try { alreadyLoaded = !!existing.sheet; } catch (_sheetAccessError) {}
      }
      if (!alreadyLoaded && type === 'script') {
        alreadyLoaded = existing.readyState === 'loaded' || existing.readyState === 'complete';
      }
      if (alreadyLoaded) {
        try { existing.setAttribute('data-es-loaded', '1'); } catch (_markLoadedError) {}
        return (ES.loader.registry[id] = Promise.resolve(existing));
      }
    }
    var promise = new Promise(function (resolve, reject) {
      var node = existing;
      if (!node) {
        node = type === 'style' ? d.createElement('link') : d.createElement('script');
        if (type === 'style') {
          node.rel = 'stylesheet';
          node.href = src;
        } else {
          node.src = src;
          if (opts.module) node.type = 'module';
          if (opts.async) node.async = true;
          else node.defer = opts.defer !== false;
        }
        node.setAttribute('data-es-resource-key', id);
        if (opts.attributes) {
          Object.keys(opts.attributes).forEach(function (name) { node.setAttribute(name, opts.attributes[name]); });
        }
      }
      var cleanup = function () {
        node.removeEventListener('load', done);
        node.removeEventListener('error', fail);
      };
      var done = function () {
        cleanup();
        node.setAttribute('data-es-loaded', '1');
        resolve(node);
      };
      var fail = function () {
        cleanup();
        // An errored resource cannot emit another load event. Retire it so a
        // later user interaction can make a fresh request.
        if (node.parentNode) node.parentNode.removeChild(node);
        reject(new Error('Failed to load ' + id));
      };
      node.addEventListener('load', done, { once: true });
      node.addEventListener('error', fail, { once: true });
      if (!existing) {
        try { (d.head || d.documentElement).appendChild(node); }
        catch (_appendResourceError) { fail(); }
      }
    }).catch(function (error) {
      delete ES.loader.registry[id];
      ES.warn('loader', 'Resource failed: ' + id, error, { src: src, type: type });
      if (opts.reject) throw error;
      return false;
    });
    ES.loader.registry[id] = promise;
    return promise;
  }
  ES.loader.script = function (key, src, options) { return loadResource('script', key, src, options); };
  ES.loader.style = function (key, src, options) { return loadResource('style', key, src, options); };
  ES.loader.prefetch = function (src, asType) {
    if (!src) return false;
    try {
      if (d.querySelector('link[rel="prefetch"][href="' + src.replace(/"/g, '\\"') + '"]')) return true;
      var link = d.createElement('link');
      link.rel = 'prefetch';
      link.href = src;
      if (asType) link.as = asType;
      (d.head || d.documentElement).appendChild(link);
      return true;
    } catch (error) { ES.warn('loader', 'Prefetch failed.', error, { src: src }); return false; }
  };

  ES.observe = ES.observe || {};
  (function initDomObserverHub() {
    if (ES.observe.dom) return;
    var subscribers = [];
    var observer = null;
    function ensure() {
      if (observer || !w.MutationObserver || !d.documentElement) return;
      observer = new w.MutationObserver(function (mutations) {
        subscribers.slice().forEach(function (subscriber) {
          try { subscriber(mutations); } catch (error) { ES.warn('observer', 'DOM subscriber failed.', error); }
        });
      });
      observer.observe(d.documentElement, { childList: true, subtree: true });
    }
    ES.observe.dom = function (subscriber) {
      if (typeof subscriber !== 'function') return function () {};
      subscribers.push(subscriber);
      ensure();
      return function () {
        var index = subscribers.indexOf(subscriber);
        if (index > -1) subscribers.splice(index, 1);
        if (!subscribers.length && observer) { try { observer.disconnect(); } catch (_disconnectError) {} observer = null; }
      };
    };
  })();

  (function initMutationObserverPool() {
    if (ES.observe.mutations) return;
    var rootPools = typeof WeakMap === 'function' ? new WeakMap() : null;
    var fallbackRoots = [];

    function normalizeOptions(options) {
      var source = options || {};
      var normalized = {
        childList: source.childList !== false,
        subtree: source.subtree !== false,
        attributes: !!source.attributes,
        characterData: !!source.characterData
      };
      if (normalized.attributes && Array.isArray(source.attributeFilter) && source.attributeFilter.length) {
        normalized.attributeFilter = source.attributeFilter.slice().sort();
      }
      if (normalized.attributes && source.attributeOldValue) normalized.attributeOldValue = true;
      if (normalized.characterData && source.characterDataOldValue) normalized.characterDataOldValue = true;
      return normalized;
    }

    function optionsKey(options) {
      return JSON.stringify(options);
    }

    function getRootMap(root, create) {
      if (rootPools) {
        var map = rootPools.get(root);
        if (!map && create) {
          map = {};
          rootPools.set(root, map);
        }
        return map || null;
      }
      for (var i = 0; i < fallbackRoots.length; i += 1) {
        if (fallbackRoots[i].root === root) return fallbackRoots[i].map;
      }
      if (!create) return null;
      var entry = { root: root, map: {} };
      fallbackRoots.push(entry);
      return entry.map;
    }

    function releaseFallbackRoot(root, rootMap) {
      if (rootPools || Object.keys(rootMap).length) return;
      for (var i = fallbackRoots.length - 1; i >= 0; i -= 1) {
        if (fallbackRoots[i].root === root) fallbackRoots.splice(i, 1);
      }
    }

    ES.observe.mutations = function (subscriber, options, root) {
      if (typeof subscriber !== 'function') return function () {};
      var target = root || d.documentElement;
      if (!target || !w.MutationObserver) return function () {};
      var normalized = normalizeOptions(options);
      var key = optionsKey(normalized);
      var rootMap = getRootMap(target, true);
      var pool = rootMap[key];

      if (!pool) {
        pool = rootMap[key] = { root: target, subscribers: [], observer: null };
        pool.observer = new w.MutationObserver(function (mutations) {
          pool.subscribers.slice().forEach(function (handler) {
            try { handler(mutations); }
            catch (error) { ES.warn('observer', 'Mutation subscriber failed.', error); }
          });
        });
        try { pool.observer.observe(target, normalized); }
        catch (error) {
          delete rootMap[key];
          releaseFallbackRoot(target, rootMap);
          ES.warn('observer', 'Mutation observer could not start.', error, { options: normalized });
          return function () {};
        }
      }

      pool.subscribers.push(subscriber);
      var active = true;
      return function () {
        if (!active) return;
        active = false;
        var index = pool.subscribers.indexOf(subscriber);
        if (index > -1) pool.subscribers.splice(index, 1);
        if (!pool.subscribers.length) {
          try { pool.observer.disconnect(); } catch (_disconnectMutationError) {}
          if (rootMap[key] === pool) delete rootMap[key];
          releaseFallbackRoot(target, rootMap);
        }
      };
    };
  })();

  ES.scheduler = ES.scheduler || {};
  ES.scheduler.idle = function (callback, timeout) {
    if (typeof callback !== 'function') return function () {};
    var active = true;
    var id;
    var runner = function (deadline) {
      if (!active) return;
      active = false;
      try { callback(deadline || null); }
      catch (error) { ES.warn('scheduler', 'Idle task failed.', error); }
    };
    if (w.requestIdleCallback) id = w.requestIdleCallback(runner, { timeout: timeout || 700 });
    else id = w.setTimeout(function () { runner(null); }, Math.max(0, timeout == null ? 700 : timeout));
    return function () {
      if (!active) return;
      active = false;
      try {
        if (w.requestIdleCallback && w.cancelIdleCallback) w.cancelIdleCallback(id);
        else w.clearTimeout(id);
      } catch (_cancelIdleError) {}
    };
  };

  (function initResizeObserverPool() {
    if (ES.observe.resize) return;
    var callbacks = typeof Map === 'function' ? new Map() : null;
    var fallbackEntries = [];
    var observer = null;

    function getEntry(element) {
      if (callbacks) return callbacks.get(element) || null;
      for (var i = 0; i < fallbackEntries.length; i += 1) {
        if (fallbackEntries[i].element === element) return fallbackEntries[i];
      }
      return null;
    }

    function setEntry(element, entry) {
      if (callbacks) callbacks.set(element, entry);
      else fallbackEntries.push(entry);
    }

    function deleteEntry(element) {
      if (callbacks) callbacks.delete(element);
      else {
        for (var i = fallbackEntries.length - 1; i >= 0; i -= 1) {
          if (fallbackEntries[i].element === element) fallbackEntries.splice(i, 1);
        }
      }
    }

    function entryCount() {
      return callbacks ? callbacks.size : fallbackEntries.length;
    }

    function ensureObserver() {
      if (observer || !w.ResizeObserver) return observer;
      observer = new w.ResizeObserver(function (entries) {
        entries.forEach(function (resizeEntry) {
          var record = getEntry(resizeEntry.target);
          if (!record) return;
          record.subscribers.slice().forEach(function (handler) {
            try { handler(resizeEntry, observer); }
            catch (error) { ES.warn('observer', 'Resize subscriber failed.', error); }
          });
        });
      });
      return observer;
    }

    ES.observe.resize = function (element, subscriber, options) {
      if (!element || typeof subscriber !== 'function') return function () {};
      if (!w.ResizeObserver) {
        try { subscriber({ target: element, contentRect: element.getBoundingClientRect ? element.getBoundingClientRect() : null }, null); }
        catch (error) { ES.warn('observer', 'Resize fallback failed.', error); }
        return function () {};
      }

      var activeObserver = ensureObserver();
      var record = getEntry(element);
      if (!record) {
        record = { element: element, subscribers: [] };
        setEntry(element, record);
        try { activeObserver.observe(element, options || undefined); }
        catch (error) {
          deleteEntry(element);
          ES.warn('observer', 'Resize observer could not start.', error);
          return function () {};
        }
      }
      record.subscribers.push(subscriber);

      var active = true;
      return function () {
        if (!active) return;
        active = false;
        var index = record.subscribers.indexOf(subscriber);
        if (index > -1) record.subscribers.splice(index, 1);
        if (!record.subscribers.length) {
          try { activeObserver.unobserve(element); } catch (_unobserveResizeError) {}
          deleteEntry(element);
        }
        if (!entryCount() && observer) {
          try { observer.disconnect(); } catch (_disconnectResizeError) {}
          observer = null;
        }
      };
    };
  })();

  (function initIntersectionObserverPool() {
    if (ES.observe.intersection) return;
    var rootPools = typeof WeakMap === 'function' ? new WeakMap() : null;
    var viewportPools = {};
    var fallbackRoots = [];

    function optionsKey(options) {
      var opts = options || {};
      var threshold = opts.threshold == null ? 0 : opts.threshold;
      if (Array.isArray(threshold)) threshold = threshold.slice().sort(function(a, b){ return a - b; });
      return [opts.rootMargin || '0px', JSON.stringify(threshold)].join('|');
    }

    function getRootMap(root, create) {
      if (!root) return viewportPools;
      if (rootPools) {
        var map = rootPools.get(root);
        if (!map && create) {
          map = {};
          rootPools.set(root, map);
        }
        return map || null;
      }
      for (var i = 0; i < fallbackRoots.length; i += 1) {
        if (fallbackRoots[i].root === root) return fallbackRoots[i].map;
      }
      if (!create) return null;
      var entry = { root: root, map: {} };
      fallbackRoots.push(entry);
      return entry.map;
    }

    function releaseFallbackRoot(root, rootMap) {
      if (!root || rootPools || Object.keys(rootMap).length) return;
      for (var i = fallbackRoots.length - 1; i >= 0; i -= 1) {
        if (fallbackRoots[i].root === root) fallbackRoots.splice(i, 1);
      }
    }

    ES.observe.intersection = function (element, callback, options) {
      if (!element || typeof callback !== 'function') return function () {};
      if (!w.IntersectionObserver) {
        try { callback({ target: element, isIntersecting: true, intersectionRatio: 1 }, null); }
        catch (error) { ES.warn('observer', 'Intersection fallback failed.', error); }
        return function () {};
      }

      var opts = options || {};
      var root = opts.root || null;
      var rootMap = getRootMap(root, true);
      var key = optionsKey(opts);
      var pool = rootMap[key];

      if (!pool) {
        pool = rootMap[key] = { callbacks: new Map(), observer: null };
        pool.observer = new w.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var record = pool.callbacks.get(entry.target);
            if (!record) return;
            record.subscribers.slice().forEach(function (handler) {
              try { handler(entry, pool.observer); }
              catch (error) { ES.warn('observer', 'Intersection subscriber failed.', error); }
            });
          });
        }, opts);
      }

      var record = pool.callbacks.get(element);
      if (!record) {
        record = { subscribers: [] };
        pool.callbacks.set(element, record);
        try { pool.observer.observe(element); }
        catch (error) {
          pool.callbacks.delete(element);
          if (!pool.callbacks.size) {
            try { pool.observer.disconnect(); } catch (_disconnectIntersectionStartError) {}
            delete rootMap[key];
            releaseFallbackRoot(root, rootMap);
          }
          ES.warn('observer', 'Intersection observer could not start.', error);
          return function () {};
        }
      }
      record.subscribers.push(callback);

      var active = true;
      return function () {
        if (!active) return;
        active = false;
        var current = pool.callbacks.get(element);
        if (!current) return;
        var index = current.subscribers.indexOf(callback);
        if (index > -1) current.subscribers.splice(index, 1);
        if (!current.subscribers.length) {
          try { pool.observer.unobserve(element); } catch (_unobserveIntersectionError) {}
          pool.callbacks.delete(element);
        }
        if (!pool.callbacks.size) {
          try { pool.observer.disconnect(); } catch (_disconnectIntersectionError) {}
          if (rootMap[key] === pool) delete rootMap[key];
          releaseFallbackRoot(root, rootMap);
        }
      };
    };
  })();

  // Shared desktop Quick View capability gate. Keeping this in the cached
  // global runtime avoids repeating an inline function in theme.liquid and
  // gives Collection, PDP and the lazy loader one source of truth.
  if (typeof w.ES_quickViewAllowed !== 'function') {
    w.ES_quickViewAllowed = function () {
      var fallback = Math.max(w.innerWidth || 0, d.documentElement.clientWidth || 0) >= 992;
      return ES.media.matches('(min-width: 992px) and (hover: hover) and (pointer: fine)', fallback);
    };
  }
  ES.media.quickViewAllowed = w.ES_quickViewAllowed;

  function onReady(fn) {
    if (d.readyState === 'loading') {
      d.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function onWindowLoad(fn) {
    if (d.readyState === 'complete') {
      fn();
    } else {
      w.addEventListener('load', fn, { once: true });
    }
  }

  function clearRevealTimer() {
    if (!revealTimer) return;
    try { clearTimeout(revealTimer); } catch (e) {}
    revealTimer = 0;
  }

  function revealFooterFallbackIfNeeded() {
    if (!flags.hasFooterFallback) return;
    try {
      var visibleFooter = d.querySelector('footer.footer_v4, #shopify-section-footer footer');
      var fallback = d.getElementById('es-footer-fallback');
      if (!fallback) return;
      // Recovery is reversible: section reloads must not leave two footers visible.
      var display = visibleFooter && (visibleFooter.offsetHeight || 0) > 10 ? 'none' : 'block';
      if (fallback.style.display !== display) fallback.style.display = display;
    } catch (e) {}
  }

  function queueFooterReveal(delay) {
    clearRevealTimer();
    revealTimer = w.setTimeout(function () {
      revealTimer = 0;
      revealFooterFallbackIfNeeded();
    }, Math.max(0, delay | 0));
  }

  function ensureShopifyGetProduct() {
    if (!flags.needShopifyGetProduct) return;
    w.Shopify = w.Shopify || {};
    if (typeof w.Shopify.getProduct === 'function') return;
    w.Shopify.getProduct = function (handle, cb) {
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/products/' + encodeURIComponent(handle) + '.js', true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState !== 4) return;
          if (xhr.status >= 200 && xhr.status < 300) {
            try { if (cb) cb(JSON.parse(xhr.responseText)); } catch (e) {}
          }
        };
        xhr.send(null);
      } catch (e) {}
    };
  }

  function bootResetPassword() {
    if (!flags.resetPassword) return;
    var tries = 0;
    (function tick() {
      if (w.timber && typeof w.timber.resetPasswordSuccess === 'function') {
        try { w.timber.resetPasswordSuccess(); } catch (e) {}
        return;
      }
      tries += 1;
      if (tries < 40) w.setTimeout(tick, 50);
    })();
  }

  function bootSwatchBridge($) {
    if (!flags.hasSwatches || !$ || !$.fn) return;
    $(d)
      .off('change.esThemeSwatchBridge', '.swatch :radio')
      .on('change.esThemeSwatchBridge', '.swatch :radio', function () {
        try {
          var $radio = $(this);
          var optionIndex = $radio.closest('.swatch').attr('data-option-index');
          var optionValue = $radio.val();
          $radio
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
        } catch (e) {}
      });
  }

  function bootSlickShim($) {
    if (!flags.needSlickShim || !$ || !$.fn || $.fn.slick) return;
    $.fn.slick = function () { return this; };
  }

  function parseBoolAttr(value) {
    return String(value).toLowerCase() === 'true' || value === '1';
  }

  function initHeaderStickyFromDom() {
    var el = d.querySelector('[data-es-header-sticky="1"]');
    if (!el || typeof initHeaderSticky !== 'function') return null;
    return initHeaderSticky({
      mode: el.getAttribute('data-es-header-sticky-mode') || 'default',
      enabled: parseBoolAttr(el.getAttribute('data-es-header-sticky-enabled')),
      transparent: parseBoolAttr(el.getAttribute('data-es-header-sticky-transparent')),
      bg: el.getAttribute('data-es-header-sticky-bg') || '',
      navSelector: '.jsheader_sticky',
      headerSelector: '.header-v1-h1'
    });
  }

  function initHeaderSticky(config) {
    var cfg = config || {};
    var prev = w.__esHeaderStickyV1;
    if (prev && typeof prev.cleanup === 'function') {
      try { prev.cleanup(); } catch (e) {}
    }

    var navSelector = cfg.navSelector || '.jsheader_sticky';
    var headerSelector = cfg.headerSelector || '.header-v1-h1';
    var nav = d.querySelector(navSelector);
    if (!nav) {
      w.__esHeaderStickyV1 = null;
      return null;
    }

    var headers = d.querySelectorAll(headerSelector);
    var enabled = !!cfg.enabled;
    var transparent = !!cfg.transparent;
    var bg = cfg.bg || '';
    var rafId = 0;
    var timeoutId = 0;
    var stickyThreshold = typeof cfg.threshold === 'number' ? cfg.threshold : (transparent ? 16 : 12);

    function removeLegacySpacers() {
      try {
        d.querySelectorAll('.es-header-sticky-spacer,.es-mobile-header-sticky-spacer').forEach(function (node) {
          if (node && node.parentNode) node.parentNode.removeChild(node);
        });
      } catch (e) {}
    }

    function applyBaseBackground() {
      if (transparent || !bg) return;
      try {
        headers.forEach(function(el){ el.style.background = bg; });
      } catch (e) {}
    }

    var lastPassed = null;
    function syncHeader() {
      rafId = 0;
      timeoutId = 0;
      if (!nav) return;

      var top = w.pageYOffset || d.documentElement.scrollTop || 0;
      var passed = top > stickyThreshold;
      if (passed === lastPassed) return;
      lastPassed = passed;

      try {
        nav.classList.toggle('menu_scroll_v1', passed);
        headers.forEach(function(el){
          el.classList.toggle('menu_scroll_v1', passed);
          el.classList.toggle('es-header-sticky-compact', passed);
        });
        d.documentElement.classList.toggle('es-header-sticky-active', passed);
      } catch (e) {}

      /* MainContent owns fixed-header layout space. Never create a second spacer. */
      removeLegacySpacers();

      if (passed) {
        if (bg) {
          try {
            headers.forEach(function(el){ el.style.background = bg; });
          } catch (e) {}
        }
      } else if (transparent) {
        try {
          headers.forEach(function(el){ el.style.background = 'none'; });
        } catch (e) {}
      }
    }

    function scheduleSync() {
      if (rafId || timeoutId) return;
      if (typeof w.requestAnimationFrame === 'function') {
        rafId = w.requestAnimationFrame(syncHeader);
      } else {
        timeoutId = w.setTimeout(syncHeader, 16);
      }
    }

    function onPageShow() {
      lastPassed = null;
      applyBaseBackground();
      removeLegacySpacers();
      scheduleSync();
    }

    function onPageHide() {
      if (rafId && typeof w.cancelAnimationFrame === 'function') {
        try { w.cancelAnimationFrame(rafId); } catch (e) {}
      }
      if (timeoutId) {
        try { clearTimeout(timeoutId); } catch (e) {}
      }
      rafId = 0;
      timeoutId = 0;
    }

    function cleanup() {
      onPageHide();
      try { w.removeEventListener('scroll', scheduleSync); } catch (e) {}
      try { w.removeEventListener('resize', scheduleSync); } catch (e) {}
      try { w.removeEventListener('pageshow', onPageShow); } catch (e) {}
      try { w.removeEventListener('pagehide', onPageHide); } catch (e) {}
      try { d.documentElement.classList.remove('es-header-sticky-active'); } catch (e) {}
      try {
        headers.forEach(function(el){ el.classList.remove('es-header-sticky-compact'); });
      } catch (e) {}
      removeLegacySpacers();
    }

    applyBaseBackground();
    removeLegacySpacers();

    if (enabled) {
      scheduleSync();
      w.addEventListener('scroll', scheduleSync, { passive: true });
      w.addEventListener('resize', scheduleSync);
      w.addEventListener('pageshow', onPageShow);
      w.addEventListener('pagehide', onPageHide);
    }

    w.__esHeaderStickyV1 = {
      cleanup: cleanup,
      mode: cfg.mode || 'default',
      sync: scheduleSync
    };
    return w.__esHeaderStickyV1;
  }

  function initHeaderLayoutContract() {
    var previous = w.__esHeaderLayoutContractV1;
    if (previous && typeof previous.cleanup === 'function') {
      try { previous.cleanup(); } catch (e) {}
    }

    var root = d.documentElement;
    if (!root) return null;

    var rafId = 0;
    var timeoutIds = [];
    var resizeObserver = null;
    var mutationObserver = null;
    var lastHeaderHeight = -1;
    var lastHeaderTop = -1;
    var destroyed = false;
    var suspended = false;
    var measureDirty = true;
    var nodesDirty = true;
    var desktopHeader = null;
    var mobileHeader = null;
    var promoNode = null;
    var promoVisible = true;

    function fallbackHeight() {
      var width = w.innerWidth || root.clientWidth || 0;
      return width <= 767.98 ? 49 : 53;
    }

    function isRendered(el) {
      if (!el || !el.getBoundingClientRect) return false;
      var style;
      try { style = w.getComputedStyle(el); } catch (e) { style = null; }
      if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
      var rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    function getActiveHeader() {
      var desktop = desktopHeader;
      var mobile = mobileHeader;
      var desktopViewport = (w.innerWidth || root.clientWidth || 0) >= 1200;
      var preferred = desktopViewport ? desktop : mobile;
      var alternate = desktopViewport ? mobile : desktop;
      if (isRendered(preferred)) return preferred;
      if (isRendered(alternate)) return alternate;
      return preferred || alternate || null;
    }

    function getHeaderTopOffset() {
      var promo = promoNode;
      if (!promo || !promo.isConnected || !promoVisible) return 0;
      var rect = promo.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return 0;
      var height = Math.max(0, Number(rect.height || promo.offsetHeight || 0));
      var bottom = Number(rect.bottom);
      if (!Number.isFinite(bottom)) bottom = height;
      /* The promo is in normal flow. As it scrolls away, the fixed Header must
         rise with its visible bottom instead of leaving an empty strip above. */
      return Math.max(0, Math.min(height, bottom));
    }

    function removeLegacySpacers() {
      try {
        d.querySelectorAll('.es-header-fixed-spacer,.es-mobile-header-fixed-spacer,.es-header-sticky-spacer,.es-mobile-header-sticky-spacer').forEach(function (node) {
          if (node && node.parentNode) node.parentNode.removeChild(node);
        });
      } catch (e) {}
    }

    function applyMeasurement() {
      rafId = 0;
      if (destroyed || suspended) return;
      if (nodesDirty) {
        nodesDirty = false;
        removeLegacySpacers();
        observeCurrentNodes();
      }
      var measured = lastHeaderHeight;
      if (measureDirty || !resizeObserver || measured < 0) {
        if (promoNode) {
          var promoStyle = w.getComputedStyle(promoNode);
          promoVisible = promoStyle.display !== 'none' && promoStyle.visibility !== 'hidden';
        }
        measureDirty = false;
        var activeHeader = getActiveHeader();
        measured = 0;
        if (activeHeader) {
          var rect = activeHeader.getBoundingClientRect();
          measured = Number(rect.height || activeHeader.offsetHeight || 0);
        }
        if (measured < 1 || measured > 240) measured = fallbackHeight();
        measured = Math.round(measured * 100) / 100;
      }

      var headerTop = getHeaderTopOffset();
      headerTop = Math.round(headerTop * 100) / 100;

      if (Math.abs(measured - lastHeaderHeight) > 0.01) {
        lastHeaderHeight = measured;
        root.style.setProperty('--es-header-content-offset', measured + 'px');
      }
      if (Math.abs(headerTop - lastHeaderTop) > 0.01) {
        lastHeaderTop = headerTop;
        root.style.setProperty('--es-header-top-offset', headerTop + 'px');
      }
      if (root.getAttribute('data-es-header-layout-ready') !== '1') root.setAttribute('data-es-header-layout-ready', '1');
    }

    function scheduleScroll() { schedule(false); }
    function schedule(remeasure) {
      if (destroyed || suspended) return;
      if (remeasure !== false) measureDirty = true;
      if (rafId) return;
      if (typeof w.requestAnimationFrame === 'function') {
        rafId = w.requestAnimationFrame(applyMeasurement);
      } else {
        rafId = w.setTimeout(applyMeasurement, 16);
      }
    }

    function queue(delay) {
      var id = w.setTimeout(function () {
        timeoutIds = timeoutIds.filter(function (candidate) { return candidate !== id; });
        schedule();
      }, delay);
      timeoutIds.push(id);
    }

    function observeCurrentNodes() {
      desktopHeader = d.querySelector('[data-es-layout-header="desktop"],.header-v1-h1.es-header-fixed');
      mobileHeader = d.querySelector('[data-es-layout-header="mobile"],.menu_moblie.es-mobile-header-fixed');
      promoNode = d.querySelector('.promo_topbar');
      var headerMount = d.getElementById('shopify-section-header');
      if (resizeObserver) {
        resizeObserver.disconnect();
        [desktopHeader, mobileHeader, promoNode, headerMount].forEach(function(node) {
          if (node) { try { resizeObserver.observe(node); } catch(e) {} }
        });
      }
      if (mutationObserver) {
        mutationObserver.disconnect();
        var layoutMount = d.querySelector('.contentbody') || d.body;
        if (layoutMount) mutationObserver.observe(layoutMount, { childList: true });
        if (headerMount && headerMount !== layoutMount) mutationObserver.observe(headerMount, { childList: true, subtree: true });
        if (promoNode) mutationObserver.observe(promoNode, { attributes: true, attributeFilter: ['class','style'] });
      }
    }
    function onStructureChange() {
      nodesDirty = true;
      schedule();
    }
    function cancelPending() {
      if (rafId) {
        if (w.cancelAnimationFrame) w.cancelAnimationFrame(rafId);
        else w.clearTimeout(rafId);
        rafId = 0;
      }
      timeoutIds.forEach(function(id) { w.clearTimeout(id); });
      timeoutIds = [];
    }
    function onPageHide() {
      suspended = true;
      cancelPending();
      if (resizeObserver) resizeObserver.disconnect();
      if (mutationObserver) mutationObserver.disconnect();
    }
    function onPageShow() {
      if (destroyed) return;
      suspended = false;
      nodesDirty = true;
      schedule();
    }

    function cleanup() {
      destroyed = true;
      if (rafId) {
        if (typeof w.cancelAnimationFrame === 'function') {
          try { w.cancelAnimationFrame(rafId); } catch (e) {}
        } else {
          try { w.clearTimeout(rafId); } catch (e) {}
        }
        rafId = 0;
      }
      timeoutIds.forEach(function (id) { try { w.clearTimeout(id); } catch (e) {} });
      timeoutIds = [];
      if (resizeObserver) { try { resizeObserver.disconnect(); } catch (e) {} }
      if (mutationObserver) { try { mutationObserver.disconnect(); } catch (e) {} }
      try { w.removeEventListener('scroll', scheduleScroll); } catch (e) {}
      try { w.removeEventListener('resize', schedule); } catch (e) {}
      try { w.removeEventListener('orientationchange', schedule); } catch (e) {}
      try { w.removeEventListener('load', schedule); } catch (e) {}
      w.removeEventListener('pagehide', onPageHide);
      w.removeEventListener('pageshow', onPageShow);
      ['shopify:section:load','shopify:section:unload','shopify:section:reorder','shopify:section:select','shopify:section:deselect'].forEach(function (name) {
        try { d.removeEventListener(name, onStructureChange); } catch (e) {}
      });
    }

    if (typeof w.ResizeObserver === 'function') resizeObserver = new w.ResizeObserver(schedule);
    if (typeof w.MutationObserver === 'function') mutationObserver = new w.MutationObserver(onStructureChange);

    w.addEventListener('scroll', scheduleScroll, { passive: true });
    w.addEventListener('resize', schedule, { passive: true });
    w.addEventListener('orientationchange', schedule, { passive: true });
    w.addEventListener('load', schedule);
    w.addEventListener('pagehide', onPageHide);
    w.addEventListener('pageshow', onPageShow);
    ['shopify:section:load','shopify:section:unload','shopify:section:reorder','shopify:section:select','shopify:section:deselect'].forEach(function (name) {
      d.addEventListener(name, onStructureChange);
    });

    if (d.fonts && d.fonts.ready && typeof d.fonts.ready.then === 'function') {
      d.fonts.ready.then(schedule).catch(function () {});
    }

    applyMeasurement();
    queue(60);
    queue(350);

    w.__esHeaderLayoutContractV1 = {
      cleanup: cleanup,
      sync: schedule
    };
    return w.__esHeaderLayoutContractV1;
  }


  w.__ES_THEME_INIT_HEADER_STICKY = initHeaderSticky;
  w.__ES_THEME_INIT_HEADER_LAYOUT = initHeaderLayoutContract;

  

  function rehydrate() {
    revealFooterFallbackIfNeeded();
    queueFooterReveal(60);
    initHeaderStickyFromDom();
    initHeaderLayoutContract();
  }

  onReady(function () {
    revealFooterFallbackIfNeeded();
    initHeaderStickyFromDom();
    initHeaderLayoutContract();
  });
  onWindowLoad(function () {
    revealFooterFallbackIfNeeded();
    queueFooterReveal(60);
  });
  function onFooterSectionChange(event) {
    var target = event.target;
    if (target && (target.id === 'shopify-section-footer' ||
        (target.querySelector && target.querySelector('footer')))) queueFooterReveal(60);
  }
  d.addEventListener('shopify:section:load', onFooterSectionChange);
  d.addEventListener('shopify:section:unload', onFooterSectionChange);
  w.addEventListener('pageshow', rehydrate);
  w.addEventListener('pagehide', clearRevealTimer);
  ensureShopifyGetProduct();
  // Third-party overlays (Judge.me / Wishlist / MUI, etc.) are intentionally left to their native styles.
  // Earlier runtime unification caused late visual swaps (e.g. Judge.me overlay changing after open).
  // Keep first-party modals/drawers unified via CSS, but do not mutate third-party overlays at runtime.

  if (typeof w.ES_jqReady === 'function') {
    w.ES_jqReady(function ($) {
      bootResetPassword();
      bootSwatchBridge($);
      bootSlickShim($);
    });
  } else {
    onReady(function () {
      if (w.jQuery) {
        bootResetPassword();
        bootSwatchBridge(w.jQuery);
        bootSlickShim(w.jQuery);
      }
    });
  }

  w.__ES_THEME_RUNTIME_REHYDRATE = rehydrate;
})(window, document);

;(function(w,d){
  if (w.__ES_LIVE_CTA_SPINNER_BOOTED) return;
  w.__ES_LIVE_CTA_SPINNER_BOOTED = true;

  var activeSelector = [
    'form[action*="/cart/add"] .es-cart-submit-pending',
    'form[action*="/cart/add"] .es-cart-submit-lock',
    'form[action*="/cart/add"] [aria-busy="true"]',
    '[data-es-lensbuilder-launch][aria-busy="true"]',
    '.es-pdp-primary-cta[aria-busy="true"]',
    '.es-pdp-primary-cta.es-cart-submit-pending',
    '.es-pdp-primary-cta.es-cart-submit-lock',
    '.btn-addToCart[aria-busy="true"]',
    '.btn-addToCart.is-loading',
    '.es-qv-select-lenses[aria-busy="true"]',
    '.es-qv-select-lenses.is-loading'
  ].join(',');

  var candidateSelector = [
    'form[action*="/cart/add"] button',
    'form[action*="/cart/add"] [type="submit"]',
    '[data-es-lensbuilder-launch]',
    '.es-pdp-primary-cta',
    '.btn-addToCart',
    '.es-qv-select-lenses'
  ].join(',');

  function makeSpinner(){
    var span = d.createElement('span');
    span.className = 'es-live-cta-spinner';
    span.setAttribute('aria-hidden', 'true');
    return span;
  }

  function isActive(el){
    if (!el || !el.matches) return false;
    try { return el.matches(activeSelector); } catch(e) { return false; }
  }

  function ensure(el){
    if (!el || !el.querySelector) return;
    var spinner = el.querySelector(':scope > .es-live-cta-spinner');
    try {
      var spinners = el.querySelectorAll(':scope > .es-live-cta-spinner');
      if (spinners && spinners.length > 1) {
        for (var i = 1; i < spinners.length; i += 1) {
          if (spinners[i] && spinners[i].parentNode) spinners[i].parentNode.removeChild(spinners[i]);
        }
        spinner = spinners[0] || spinner;
      }
    } catch(eDup) {}
    if (isActive(el)) {
      if (!spinner) el.appendChild(makeSpinner());
      try { el.setAttribute('data-es-live-spinner', '1'); } catch(e) {}
    } else {
      if (spinner) spinner.parentNode.removeChild(spinner);
      try { el.removeAttribute('data-es-live-spinner'); } catch(e) {}
    }
  }

  function sync(root){
    root = root && root.querySelectorAll ? root : d;
    try {
      if (root.matches && root.matches(candidateSelector)) ensure(root);
    } catch(e0) {}
    try {
      root.querySelectorAll(candidateSelector).forEach(ensure);
    } catch(e1) {}
  }

  var scheduled = 0;
  function schedule(root){
    if (scheduled) return;
    scheduled = w.setTimeout(function(){
      scheduled = 0;
      sync(root || d);
    }, 0);
  }

  var stopMutationWatch = null;

  function onSpinnerMutations(muts){
    for (var i = 0; i < muts.length; i += 1) {
      var m = muts[i];
      if (m.type === 'attributes') {
        var t = m.target;
        if (t && t.matches && t.matches(candidateSelector)) ensure(t);
      } else if (m.type === 'childList') {
        schedule(d);
      }
    }
  }

  function boot(){
    sync(d);
    try {
      if (w.ES && w.ES.observe && typeof w.ES.observe.mutations === 'function') {
        stopMutationWatch = w.ES.observe.mutations(onSpinnerMutations, {
          subtree:true,
          childList:true,
          attributes:true,
          attributeFilter:['class','aria-busy','disabled','aria-disabled']
        }, d.documentElement);
      } else if (w.MutationObserver) {
        var fallbackObserver = new w.MutationObserver(onSpinnerMutations);
        fallbackObserver.observe(d.documentElement, { subtree:true, childList:true, attributes:true, attributeFilter:['class','aria-busy','disabled','aria-disabled'] });
        stopMutationWatch = function(){ try { fallbackObserver.disconnect(); } catch(_disconnectError) {} };
      }
    } catch(e) {
      if (w.ES && typeof w.ES.warn === 'function') w.ES.warn('cta-spinner', 'Mutation watch failed.', e);
    }
  }

  d.addEventListener('click', function(){ schedule(d); }, true);
  d.addEventListener('submit', function(){ schedule(d); }, true);
  w.__ES_CTA_SPINNER_SYNC = function(){ sync(d); };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
})(window, document);
